module.exports = __webpack_public_path__ + "media/images/amenities_icons/community_lunches-4bbee26950d0368e0f619beca4627dce.svg";